module.exports = __webpack_public_path__ + "img/home-page-text.8550d58d.png";